<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Budget Realization Ledger 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="6" xl="4">
                  <b-input-group >
                        <b-input-group-prepend><label>Date Range</label></b-input-group-prepend>
                        <b-form-input v-model="model.tgl1" type="date" ></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="model.tgl2" type="date" @change="updateTgl1" :state="!$v.model.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4" xl="3">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Account</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.kodeawinfo" :state="!$v.model.kodeaw.$error" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('kodeaw')">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row >
            <!-- <b-row >
                <b-col lg="4">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tgl1" type="date" @change="updateTgl2" :state="!$v.model.tgl1.$error"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="model.tgl2" type="date" @change="updateTgl1" :state="!$v.model.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="8">
                    <b-form-group label-cols=1 label-align="right" label="Account">
                        <b-row>
                            <b-col class="pr-1" cols="5">
                                <b-input-group >
                                    <b-form-input readonly v-model="model.kodeawinfo" :state="!$v.model.kodeaw.$error" ></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="showLkuCoa('kodeaw')">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                            <b-col class="pl-1" cols="6">
                                <b-form-group label-cols=1 label="until">
                                    <b-input-group >
                                        <b-form-input readonly v-model="model.kodeakinfo" ></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="showLkuCoa('kodeak')">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>

                            </b-col>
                        </b-row>                      
                    </b-form-group>
                </b-col>
            </b-row > -->
            <b-row >
                <b-col lg="10" xl="8">
                  <b-input-group >
                        <b-input-group-prepend><label>Dept/Div/Dir</label></b-input-group-prepend>
                        <b-form-radio-group  class="mt-2" v-model="model.opsiDept" name="radioDept" :state="!$v.model.opsiDept.$error">
                            <b-form-radio value="1">All</b-form-radio>
                            <b-form-radio value="2">Empty (Non Dept)</b-form-radio>
                            <b-form-radio value="3">Choice</b-form-radio>
                        </b-form-radio-group>
                        <b-form-select v-model="model.DimCol" :state="!$v.model.DimCol.$error" :plain="true" :options="['Department','Division','Directorat']" :disabled="(model.opsiDept!=3)"></b-form-select>
                        <b-form-input v-model="model.departemen" :state="!$v.model.departkd.$error" placeholder="Value" class="ml-1" disabled style="width:27%"></b-form-input>
                        <b-input-group-append v-if="(model.opsiDept==3)">
                            <b-btn text="Button" @click="lkuDeptShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="2" xl="1">
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Process</b-button>
                </b-col>
            </b-row >

      <b-card no-body>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblFields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filterInput"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
              <template v-slot:cell(tanggal)="data">
                  {{ data.item.tanggal | moment("DD-MMM-YYYY") }}
                  <!-- <span v-if="(data.item.tanggal)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span> -->
              </template>
                <template v-slot:cell(nomor)="data">
                        <span v-if="(data.item.nomor=='BEGINING')">{{data.item.nomor}}</span>
                        <span v-else ><b-link @click.stop="printJv(data.item)">{{data.item.nomor}}</b-link></span>
                </template>

                <template v-slot:cell(umasuk)="data">
                      {{ data.item.umasuk | numFormat }}
                </template>
                <template v-slot:cell(ukeluar)="data">
                      {{ data.item.ukeluar | numFormat }}
                </template>
                <template v-slot:cell(sakhir)="data">
                      {{ data.item.sakhir | numFormat }}
                </template>
            </b-table>
        <b-row class="m-1">
          <b-col lg="6">            
            <b-row v-if="(filterShow=='Hide')">
                  <b-input-group size="sm">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group size="sm" class="ml-4">
                      <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                        <b-form-checkbox value="nomor">Voucher Number</b-form-checkbox>
                        <b-form-checkbox value="uraian">Description</b-form-checkbox>
                        <b-form-checkbox value="umasuk">Debit Amount</b-form-checkbox>
                        <b-form-checkbox value="ukeluar">Credit Amount</b-form-checkbox>
                      </b-form-checkbox-group>
                  </b-input-group>
                  <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch >
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>
          </b-col>
          <b-col lg="6">
            <div style="display: flex;margin:0;padding:0;">
                <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} ,   <span class="mr-1">limit per page :</span> 
                    <select  v-model="tblLcy.limit"  style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>                            
                      <option>25</option>
                      <option>30</option>                            
                      <option>40</option>                            
                      <option>50</option>                            
                      <option>60</option>                            
                      <option>70</option>                            
                      <option>80</option>                            
                      <option>90</option>                            
                    </select>
                </div>
                <div>
                    <b-pagination  class="ml-1" 
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun" :allowHeader="true"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuDeptShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDept"></lku-department>
        </b-modal>        

    </div>
</template>

<style lang="scss" scoped>
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuCoa from "../lookup/lkuCoa";
import buku from "../../apis/buku";
import budget from "../../apis/budget_dept";
import myNumber from "../../components/my-number";
import lkuDepartment from "../lookup/lkuDepartment";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required,requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        opsiDept: { required },
        DimCol: { required },
        departkd: {
                required: requiredIf(function () {
                    return this.model.opsiDept==3
                })
            },
        kodeaw: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      model: {opsiDept:3, DimCol:'Department', departkd:'', kodeaw:'', kodeaw:'',tgl1:'',tgl2:'', tabIndex:1},
      isLoading: false,
      horizontal: true,
      reportUrl: `${location.origin}/#load`,
      showReport:false,
      tahun:moment(this.$store.state.user.tglaktif).format('YYYY'),
      lkuDeptShow:false,
      lkuCoaShow:false,
      lkuCoaCaller:'kodeaw',
      rptLines : [],
      filterShow:'Show',
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      filter: null,
      filterOn: [],   
    };
  },
components: { Loading, lkuCoa, myNumber, lkuDepartment },  
computed:{
    dimension(){
      return this.$store.state.dimension;
    },
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor",
            label: "Trx. Number",
            sortable: true
          },
        {
          key: "uraian",
          label: "Description",
        },
        {
          key: "createby",
          label: "Create By",
          sortable: true
        },
        {
          key: "umasuk",
          label: "Debit (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "ukeluar",
          label: "Credit (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "sakhir",
          label: "End Balance  (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },    

  },
created: async function (){
    // const { user } = this.$store.state;
//  this.tahun=moment(user.tglaktif).format('YYYY');
    if (this.$route.params.tgl1 || this.$route.params.tgl2 || this.$route.params.kodeaw  || this.$route.params.departkd) {
        this.model.kodeaw = this.$route.params.kodeaw;
        this.model.kodeak = this.$route.params.kodeak || this.model.kodeaw; 
        this.model.kodeawinfo = this.$route.params.kodeaw + ' | ' + this.$route.params.namaacc;        
        this.model.kodeakinfo = this.$route.params.kodeak || this.model.kodeawinfo;
        this.model.tgl1=this.$route.params.tgl1;
        this.model.tgl2=this.$route.params.tgl2;
        this.model.opsiDept=this.$route.params.opsidept || 3;
        if (this.model.opsiDept==3) {
            this.model.DimCol=this.$route.params.dimcol || 'Department';
            this.model.departkd=this.$route.params.departkd || '';
            this.model.departemen = this.$route.params.departkd + ' | ' + this.$route.params.departnm;
        }
        this.process();
    } else {
         var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=`${tgl2.format('YYYY-MM')}-01`;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
        this.tahun=tgl2.format('YYYY');
    }
},
methods:{
    onSelectLkuDept: async function (_selected) {
        this.lkuDeptShow=false;
        if (this.model.DimCol=='Department') {
            this.model.departemen = _selected.departkd.trim() + ' | ' + _selected.departemen.trim();
            this.model.departid = _selected.departid;
            this.model.departkd = _selected.departkd;
        } else  if (this.model.DimCol=='Division') {
            this.model.departemen = _selected.division;
            this.model.departid = _selected.division;
            this.model.departkd = _selected.division;
        } else {
            this.model.departemen = _selected.directorate;
            this.model.departid = _selected.directorate;
            this.model.departkd = _selected.directorate;
        }
    },
    // updateTgl1: function() {
    //     var tgl2 = moment(this.model.tgl2, 'YYYY-MM-DD');
    //     if (!this.model.tgl1){
    //         this.model.tgl1=`${tgl2.format('YYYY-MM')}-01`;
    //         this.tahun=tgl2.format('YYYY');
    //         this.$forceUpdate();
    //     } else {
    //         var tgl1 = moment(this.model.tgl1, 'YYYY-MM-DD');
    //         if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
    //             this.model.tgl1=`${tgl2.format('YYYY')}-01-01`;
    //             this.tahun=tgl2.format('YYYY');
    //             this.$forceUpdate();
    //         }
    //     }
    // },
    // updateTgl2: function() {
    //     var tgl1 = moment(this.model.tgl1, 'YYYY-MM-DD');
    //     if (!this.model.tgl2){
    //         this.model.tgl2=`${tgl1.format('YYYY')}-12-31`;
    //         this.tahun=tgl1.format('YYYY');
    //         this.$forceUpdate();
    //     } else {
    //         var tgl2 = moment(this.model.tgl2, 'YYYY-MM-DD');
    //         if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
    //             this.model.tgl2=`${tgl1.format('YYYY')}-12-31`;
    //             this.tahun=tgl1.format('YYYY');
    //             this.$forceUpdate();
    //         }
    //     }
    // },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      // this.totalUmasuk = filteredItems.reduce((a, b) => a + b.umasuk, 0);
      // this.totalUkeluar = filteredItems.reduce((a, b) => a + b.ukeluar, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    process: async function(ctx) {

        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
          this.isLoading=true;
          var tgl1 = moment(this.model.tgl1, 'YYYY-MM-DD');
            var tgl2 = moment(this.model.tgl2, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                // this.model.tgl2=`${tgl1.format('YYYY')}-12-31`;
                this.model.tgl1=`${tgl2.format('YYYY')}-01-01`;
                this.tahun=tgl2.format('YYYY');
                this.$forceUpdate();
            }
        this.rptLines= await budget.ledger(this.model);      
        this.tblLcy.total = this.rptLines.length;        
        // this.totalUmasuk = this.rptLines.reduce((a, b) => a + b.umasuk, 0);
        // this.totalUkeluar = this.rptLines.reduce((a, b) => a + b.ukeluar, 0);
        // this.totalUmasuk = this.rptLines[this.tblLcy.total-1].umasuk;
        // this.totalUkeluar = this.rptLines[this.tblLcy.total-1].ukeluar;
        // this.sakhir = this.rptLines[this.tblLcy.total-1].sakhir;
        this.isLoading=false;      
       }
    },

    exportxls: async function() {
        if (this.invalidFilter) {
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await budget.ledgerexport(this.model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    confirmAction: function() {
        toastr.info('Klik Pada kolom JV.NUMBER untuk PRINT VOUCHER');
    },
    printJv: async function(data){
       if ((data.kodeacc) && (data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          try {
              this.reportUrl= await buku.printjv(data);
              this.showReport=true;
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller==='kodeaw'){
            this.model.kodeawinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model.kodeaw = _selected.kodeacc;
        } else {
            this.model.kodeakinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model.kodeak = _selected.kodeacc;
        }
        this.lkuCoaShow=false;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'accounting.gl')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        //   router.push("/accounting/home");
          router.push("home");
      }

    }
    
  }
};
</script>
